import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './Weather.css';

import { trackEvent } from '../../actions/analyticsActions';
import { switchLayer } from '../../utils/url';
import { FIELD_SUMMARY } from '../../constants/mapLayerIds';
import { MICROSOFT_WEATHER } from '../../constants/featureFlags';
import WeatherApp from '../../weather'

export function Weather({
  field,
  userId,
  trackAnalyticsEvent,
  isMicrosoftWxFeatureAvailable,
  userCountryFeatures,
  fieldFeatures
}) {
  const handleClose = () => {
    trackAnalyticsEvent('weather_context_card', 'closed');
    switchLayer(0, FIELD_SUMMARY); // return to field summary when weather is closed.
  };

  return (
    <div className={styles.weatherWrapper} data-test-id="weather-wrapper">
      <div className={styles.topBar}>
        <Button
          className={styles.close}
          data-test-id="weather-close-button"
          mode="secondary"
          onClick={handleClose}
        >
          {getMessage('close')}
        </Button>
      </div>
      <div className={styles.iframeWrapper}>
        <Suspense fallback={<div />}>
          <WeatherApp
            fieldId={field.id}
            userId={userId}
            userCountryFeatures={userCountryFeatures}
            fieldFeatures={fieldFeatures}
            isMicrosoftWxFeatureAvailable={isMicrosoftWxFeatureAvailable}
          />
        </Suspense>
      </div>
    </div>
  );
}

Weather.propTypes = {
  field: PropTypes.object,
  trackAnalyticsEvent: PropTypes.func.isRequired,
  userId: PropTypes.number,
  isMicrosoftWxFeatureAvailable: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const microsoftFeatureFlag =
    state.feature.userConfigFeatures[MICROSOFT_WEATHER];


  return {
    isMicrosoftWxFeatureAvailable: microsoftFeatureFlag.value,
    userCountryFeatures: state.user.countryFeatures,
    fieldFeatures: state.field.features,
  };
};

const mapDispatchToProps = {
  trackAnalyticsEvent: trackEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(Weather);
